import { render, staticRenderFns } from "./CreateDeliveryZone.vue?vue&type=template&id=0b8fe906&scoped=true&"
import script from "./CreateDeliveryZone.vue?vue&type=script&lang=js&"
export * from "./CreateDeliveryZone.vue?vue&type=script&lang=js&"
import style0 from "./CreateDeliveryZone.vue?vue&type=style&index=0&id=0b8fe906&scoped=true&lang=css&"
import style1 from "./CreateDeliveryZone.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8fe906",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAutocomplete,VSnackbar})
